import { Outlet } from "react-router";
import { FilterProvider } from "../../../context/FilterProvider";

const LearningPlanFilter = () => {
    return (
        <FilterProvider>
            <Outlet />
        </FilterProvider>
    );
}

export default LearningPlanFilter;